export default __webpack_public_path__ + "static/media/cabello-corto-hombre-pelirrojo.28a1b1fb.png";